"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OCRResultTransport = exports.OCRMetadata = exports.OCRResult = exports.OCRDumpTicketSchema = exports.OCRStatus = exports.OCRStatuses = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
exports.OCRStatuses = ['QUEUED', 'IN_PROGRESS', 'COMPLETE', 'FAILED'];
exports.OCRStatus = typebox_1.Type.Union(exports.OCRStatuses.map((status) => typebox_1.Type.Literal(status)));
exports.OCRDumpTicketSchema = typebox_1.Type.Object({
    isDumpTicket: typebox_1.Type.Boolean({
        description: 'Whether the image is a dump ticket. Dump tickets are usually formatted like an invoice or receipt.',
    }),
    tonsDumped: typebox_1.Type.Optional(typebox_1.Type.Number({ description: 'The number of tons dumped according to the dump ticket' })),
    dumpedMaterial: typebox_1.Type.Optional(typebox_1.Type.String({ description: 'The material dumped according to the dump ticket' })),
    rawWeight: typebox_1.Type.Optional(typebox_1.Type.Number({ description: 'The raw weight of the dump according to the dump ticket' })),
    dumpsterSize: typebox_1.Type.Optional(typebox_1.Type.String({ description: 'The size of the dumpster according to the dump ticket, if it is available' })),
    weightUnit: typebox_1.Type.Optional(typebox_1.Type.String({
        description: 'The unit of weight of the dump according to the dump ticket. Please respond with "TONS" or "LBS" if you can determine the unit of weight. Normally if the weight is in pounds it won\'t have a decimal point. If the weight is in tons it will have a decimal point(s). If you cannot determine the unit of weight, respond with "UNKNOWN".',
    })),
    cost: typebox_1.Type.Optional(typebox_1.Type.Number({ description: 'The cost of the dump according to the dump ticket' })),
    facilityName: typebox_1.Type.Optional(typebox_1.Type.String({ description: 'The name of the facility where the dump was dumped' })),
    dateDumped: typebox_1.Type.Optional(typebox_1.Type.String({
        description: 'The date the dump was dumped according to the dump ticket. This may just be the date the dump ticket was created. You should use the scale in date if it is available. Return dates in yyyy-MM-dd format.',
    })),
});
exports.OCRResult = typebox_1.Type.Union([
    typebox_1.Type.Object({
        type: typebox_1.Type.Literal('dump-ticket'),
        dumpTicket: exports.OCRDumpTicketSchema,
    }),
    typebox_1.Type.Object({
        type: typebox_1.Type.Literal('other'),
        other: typebox_1.Type.Unknown(),
    }),
]);
exports.OCRMetadata = typebox_1.Type.Partial(typebox_1.Type.Object({
    processingTimeMs: typebox_1.Type.Number(),
    model: typebox_1.Type.String(),
    promptTokenCount: typebox_1.Type.Number(),
    candidatesTokenCount: typebox_1.Type.Number(),
    totalTokenCount: typebox_1.Type.Number(),
    cachedContentTokenCount: typebox_1.Type.Number(),
}));
exports.OCRResultTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    status: exports.OCRStatus,
    s3ItemReference: common_1.S3ItemReference,
    results: typebox_1.Type.Optional(exports.OCRResult),
    OCRMetadata: typebox_1.Type.Optional(exports.OCRMetadata),
    processedAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    error: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: common_1.MetaData,
});
//# sourceMappingURL=order-image-ocr.js.map